import { type ComponentPropsWithoutRef, type ReactNode } from "react";
import cx from "classnames";

import { useComboboxLegacy } from "./ComboboxLegacy";

import { Flex } from "../Flex";
import { Text } from "../Text";
import { Spinner } from "../Spinner";

import styles from "./ComboboxLegacy.module.scss";
import listboxStyles from "../Listbox/Listbox.module.scss";
import listViewStyles from "../ListView/ListView.module.scss";

export type ComboboxLegacyListProps = ComponentPropsWithoutRef<"ul" | "div"> & {
  children?: ReactNode;
};

export const ComboboxLegacyList = function <Item = any>({
  children,
  ...rest
}: ComboboxLegacyListProps) {
  const {
    getMenuProps,
    multiple,
    items,
    hasAddNew = false,
    hasEmpty,
    loading,
  } = useComboboxLegacy<Item>();

  if (multiple) {
    return (
      <>
        <div
          {...getMenuProps(rest as ComponentPropsWithoutRef<"div">)}
          data-anv="combobox-list"
          className={cx(styles["listview"], listViewStyles["listview"])}
          style={{
            display: items.length || hasAddNew ? undefined : "none",
            overflow: "auto",
          }}
        >
          {children}

          {loading ? (
            <Flex justifyContent="center">
              <Spinner className={styles["loading-spinner"]} />
            </Flex>
          ) : null}
        </div>

        {!items.length && !hasEmpty ? (
          <div className={styles["empty"]}>
            <Text subdued size="small">
              No match found
            </Text>
          </div>
        ) : null}
      </>
    );
  } else {
    return (
      <>
        <ul
          {...getMenuProps(rest as ComponentPropsWithoutRef<"ul">)}
          data-anv="combobox-list"
          className={listboxStyles["listbox"]}
          style={{
            display: items.length || hasAddNew ? undefined : "none",
            overflow: "auto",
          }}
        >
          {children}

          {loading ? (
            <li>
              <Flex justifyContent="center">
                <Spinner className={styles["loading-spinner"]} />
              </Flex>
            </li>
          ) : null}
        </ul>

        {!items.length && !hasEmpty ? (
          <div className={styles["empty"]}>
            <Text subdued size="small">
              No match found
            </Text>
          </div>
        ) : null}
      </>
    );
  }
};
